import React, { useEffect, useState } from 'react'
import SimplePagination from 'components/shared/SimplePagination.js/index'
import { getPaginationHeaders } from 'constants/utilityFunctions'
import { getAllStatesSavedRecords } from 'actions/applicants'
import strings from 'strings'
import AllStatesSavedRecordsColumns from './AllStatesSavedRecordsColumns'
import AllStatesSavedRecordCard from './AllStatesSavedRecordCard'
import { Alert } from '@material-ui/lab'
import Loader from 'components/shared/Loader'

const sosStrings = strings.APPLICANT.SOS

const AllStatesSavedRecords = (props) => {

    const { viewResult, applicantId } = props

    const [savedRecords, setSavedRecords] = useState([])

    const savedRecordsData = savedRecords?.response || []
    const savedRecordsPagination = getPaginationHeaders(savedRecords)

    const [paginationParams, setPaginationParams] = useState({})
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        getAllStatesSavedRecords(applicantId, paginationParams)()
            .then(res => {
                setSavedRecords(res)
            })
            .finally(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationParams])

    return (
        <div className='cardStyle mt-3 mb-3'>
            <div className='uccTitleContainer mt-3'><h5>{sosStrings.SAVED_RECORDS}</h5> </div>
            {loading ?
                <Loader />
                :
                (savedRecordsData?.length > 0 ?
                    <>
                        <AllStatesSavedRecordsColumns />
                        {savedRecordsData.map((item) => (
                            <AllStatesSavedRecordCard
                                key={item.uuid}
                                savedRecord={item}
                                applicantId={applicantId}
                                viewResult={viewResult}
                            />
                        ))}
                    </>
                    :
                    <Alert severity="warning">{sosStrings.NO_RECORDS_SAVED}</Alert>
                )
            }
            {savedRecordsPagination?.totalRecords > 0 &&
                <SimplePagination
                    onChangePagination={setPaginationParams}
                    totalRecords={savedRecordsPagination?.totalRecords}
                    totalPages={savedRecordsPagination?.totalPages}
                />
            }
        </div >
    )
}

export default AllStatesSavedRecords